"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThemeSwitcher;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _selectInput = _interopRequireDefault(require("@ux/select-input"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectInputContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SelectInputContainer",
  class: "pl-sdda9la"
});
function ThemeSwitcher({
  label,
  themes,
  dropdownProps
}) {
  const [activeTheme, setActiveTheme] = (0, _react.useState)(themes[0]);
  const handleThemeChange = theme => {
    if (theme) {
      setActiveTheme(theme);
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        document.cookie = `theme=${theme};path=/;`;
        window.location.reload();
      }
    }
  };
  (0, _react.useEffect)(() => {
    const theme = (0, _patternLibraryUtils.getCookieValue)('theme');
    if (theme) {
      setActiveTheme(theme);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(SelectInputContainer, null, /*#__PURE__*/_react.default.createElement(_selectInput.default, (0, _extends2.default)({
    id: "theme-switcher",
    name: "theme-switcher",
    label: label,
    value: activeTheme,
    onChange: handleThemeChange
  }, dropdownProps), themes?.map(theme => {
    const themeName = theme?.value || theme;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: themeName,
      value: themeName
    }, themeName);
  })));
}
ThemeSwitcher.propTypes = {
  label: _propTypes.default.string,
  themes: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])),
  dropdownProps: _propTypes.default.object
};